import React from "react";
import styled from "styled-components";
import { Theme } from "../../Theme";

// 탭 전체를 감싸는 컨테이너
const TabsContainer = styled.div`
    display: flex;
    gap: 32px;
    font-family:
        -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
        sans-serif;
`;

// 개별 탭 아이템
const TabItem = styled.div`
    font-size: 18px;
    font-weight: ${(props) => (props.$active ? "600" : "500")};
    color: ${(props) => (props.$active ? Theme.color.zinc850 : Theme.color.gray400)};
    cursor: pointer;
    padding-bottom: 8px;

    /* 밑줄 스타일 */
    border-bottom: 3px solid ${(props) => (props.$active ? Theme.color.zinc850 : "transparent")};

    /* 호버 효과 */
    &:hover {
        color: ${(props) => (props.$active ? Theme.color.zinc850 : Theme.color.neutral600)};
    }
`;

// 탭 컴포넌트
const CustomTab = ({ tabs, activeTab, onClick }) => {
    return (
        <TabsContainer>
            {tabs.map((tab) => (
                <TabItem key={tab.value} $active={activeTab === tab.value} onClick={() => onClick(tab.value)}>
                    {tab.label}
                </TabItem>
            ))}
        </TabsContainer>
    );
};

export default CustomTab;
